import { Col } from 'antd';
import { createElement } from 'react';
import './index.scss';
const DCCol = function DCCol({ type, flexType, width, style = {}, children, ...otherProps }) {
    const _style = style || {};
    const _otherProps = otherProps || {};
    _otherProps.style = _style;
    const getProps = () => {
        if (type === 'flex') {
            if (flexType === 'px') {
                return {
                    flex: `${width}px`,
                };
            }
            else {
                return {
                    flex: width,
                };
            }
        }
        else if (type === 'number') {
            return {
                span: width,
            };
        }
        else {
            return {};
        }
    };
    return (createElement(Col, { ...getProps(), ..._otherProps }, children));
};
DCCol.displayName = '列组件';
DCCol.defaultProps = {
    type: 'flex',
    width: 1,
};
export default DCCol;
